import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  template: `
  
  <div class="spinner" *ngIf="_isloading | async">

    <h4><span class="material-symbols-outlined">
      hourglass
      </span> Espere Procesando....</h4>
  
  </div>
  
  `,
  styleUrls: ['./../../app.component.css']
})
export class SpinnerComponent implements OnInit {

  _isloading = this.spiServer._isloading;

  constructor(private spiServer: SpinnerService) { }

  ngOnInit(): void {
  }

}
